import type { FC } from "react";

import { SiteBatchUpdateForm } from "src/app/features/Site/components/forms/SiteBatchUpdateForm";
import { useSiteBatchUpdateMutation } from "src/app/features/Site/services/server/SiteApi";
import type { SiteBatchUpdateEntity } from "src/app/features/Site/types/SiteBatchUpdateEntity";
import type { SiteEntity } from "src/app/features/Site/types/SiteEntity";
import { BatchUpdateDrawerButton } from "../../../../../components/DrawerForm/BatchUpdateDrawer/BatchUpdateDrawerButton";
import { useBatchUpdateDrawer } from "../../../../../components/DrawerForm/BatchUpdateDrawer/useBatchUpdateDrawer";
import type { ButtonProps } from "../../../../../components/FeatureButtons/types";

export const SiteBatchUpdateButton: FC<ButtonProps<SiteEntity>> = ({ isDisabled, items }) => {
    const [saveFormData] = useSiteBatchUpdateMutation();
    const { open, form, isDisabledFinal, isSubmitting, showDrawer, onClose, onSubmit } = useBatchUpdateDrawer<
        SiteBatchUpdateEntity,
        SiteEntity
    >(items, isDisabled, saveFormData);

    return (
        <BatchUpdateDrawerButton
            isDisabled={isDisabledFinal}
            open={open}
            onOpen={showDrawer}
            onClose={onClose}
            isSubmitting={isSubmitting}
            titleKey="site.batchUpdate.header"
        >
            <SiteBatchUpdateForm form={form} searchCallback={onSubmit} />
        </BatchUpdateDrawerButton>
    );
};
